import axios from 'axios'
import Qs from 'qs'

import Vue from 'vue'

import store from './store'

const HTTP = axios.create({
  baseURL: 'https://api.ilewasi.org/',
  headers: {
    'Content-Type': 'application/json'
  },
  paramsSerializer: function (params) {
    return Qs.stringify(params, {
      arrayFormat: 'brackets'
    })
  }
})

// Por si queremos hacer algo antes de ejecutar el request.
/* HTTP.interceptors.request.use(function(config) {
alert('ahora');
return config;
}, function(error) {
// Do something with request error
return Promise.reject(error);
}); */

HTTP.interceptors.response.use(function (response) {
  // Do something with response data
  return response
}, function (error) {
  if (error.response.status === 403) {
    if (JSON.parse(localStorage.getItem('user'))) {
      let requestRefreshToken = {
        email: JSON.parse(localStorage.getItem('user')).email,
        password: JSON.parse(localStorage.getItem('user')).password
      }
      HTTP.post('/user/refreshtoken', requestRefreshToken)
        .then(function (response) {
          localStorage.setItem('user', JSON.stringify(response.data.result))
          localStorage.setItem('token', response.data.token)
          HTTP.defaults.headers.common['Authorization'] = response.data.token
          store.dispatch('loginUser', response.data.result).then(() => {
            if (store.getters.getUser.auth) { Vue.prototype.$bus.$emit('event-redirect', '/home') } else { Vue.prototype.$bus.$emit('event-redirect', '/login'); Vue.prototype.$bus.$emit('event-toast', 'Sesión Expirada') }
          })
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$bus.$emit('event-redirect', '/login')
          Vue.prototype.$bus.$emit('event-toast', 'Sesión Expirada')
        })
    } else { Vue.prototype.$bus.$emit('event-redirect', '/login'); Vue.prototype.$bus.$emit('event-toast', 'Sesión Expirada') }
  } else return Promise.reject(error)
})

export default HTTP



// WEBPACK FOOTER //
// ./src/axios-config.js